namespace $.$$ {
	export class $shm_hitalama_map_book_page extends $.$shm_hitalama_map_book_page {
		@ $mol_mem
		override dom_tree( next?: Element ) {
			const node = super.dom_tree( next )
			this.$.$shm_hitalama_map_loading.current( this.map_id() )?.attach( node )
			return node
		}
	}
}
